import React from 'react';
import Image from 'next/image';
import { makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  title: string;
  image: string;
  color: 'primary' | 'info' | 'secondary';
  fixIcon?: boolean;
}

const DeliverySection: React.FC<Props> = ({
  title,
  children,
  image,
  color,
  fixIcon
}): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classNames(classes.leftSide, fixIcon && classes.fixIcon)}>
        <div className={classNames(classes[color], classes.line)} />

        <Image src={image} height={71} width={71} />

        <div className={classNames(classes[color], classes.circle)} />
      </div>

      <div className={classes.rightSide}>
        <Typography variant="h3" component="h2" className={classes.title}>
          {title}
        </Typography>

        {children}
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  primary: {
    backgroundColor: theme.palette.primary.main
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main
  },
  info: {
    backgroundColor: theme.palette.info.main
  },
  leftSide: {
    position: 'relative',
    minHeight: 150,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 42,
    paddingTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(2),
      width: 71,
      minWidth: 71,
      paddingTop: 0
    }
  },
  fixIcon: {
    '& *:nth-child(2)': {
      marginLeft: '4px !important',
      overflow: 'visible !important'
    }
  },
  container: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(8),
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(3)
    }
  },
  line: {
    height: 'calc(100% - 30px)',
    width: 2,
    position: 'absolute',
    top: 30,
    left: '50%',
    transform: 'translate(-50%, 0)'
  },
  circle: {
    height: 13,
    width: 13,
    borderRadius: '50%'
  },
  rightSide: {
    paddingTop: theme.spacing(1),
    '& ul': {
      paddingInlineStart: theme.spacing(3),
      margin: 0,
      marginBottom: theme.spacing(2)
    },
    '& li': {
      fontSize: '1.125rem'
    },
    '& h3': {
      marginBottom: theme.spacing(0.5)
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(2.5)
    }
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: theme.spacing(4)
  }
}));

export default DeliverySection;
